import { imageFile } from 'common/helpers/miscHelpers';

const ClubImage = (props) => {
  const { club } = props;

  if (!club.image) {
    return null;
  }

  const image = imageFile(club.image, 'large');

  return <img src={image} alt={club.title} loading="lazy" />;
};

export default ClubImage;
